"use client";
import React from 'react';
import classnames from 'classnames';
import SocialMediaLinks from '../../../../components/SocialMediaLinks';
import useScrollDirection from '../../../../utils/hooks/useScrollDirection';
import s from './BlogAuthor.module.scss';
import ContentfulImage, { FluidImage } from '../../../../components/ContentfulImage';
import FormattedDate from '../../../../components/FormattedDate';

interface BlogAuthorProps {
  name?: string | null;
  publishedDate?: string | null;
  role?: string | null;
  twitter?: string | null;
  linkedIn?: string | null;
  facebook?: string | null;
  github?: string | null;
  image?: {
    fluid?: FluidImage | null;
  } | null;
  wordCount: number;
}

const BlogAuthor: React.FC<BlogAuthorProps> = ({
  publishedDate,
  facebook = undefined,
  linkedIn = '',
  github = '',
  name,
  role,
  twitter = '',
  image = {},
  wordCount,
}) => {
  const { scrollDirection } = useScrollDirection();

  return (
    <div
      className={classnames(s.container, {
        [s.headerShown]: scrollDirection === 'up',
      })}
    >
      {publishedDate && (
        <p className={s.publishedDate}>
          Posted on&nbsp;
          <FormattedDate date={publishedDate} />
          <span> • </span>
          <span className={s.wordCount}>{`${Math.ceil(wordCount / 200)} min read`}</span>
        </p>
      )}
      <div className={s.authorContainer}>
        <div className={s.authorDetails}>
          {image?.fluid?.src && <ContentfulImage alt={name || 'Author image'} fluid={image.fluid} className={s.authorImage} />}
          <div className={s.authorInfo}>
            <h4 className={s.authorName}>{name}</h4>
            <p className={s.authorRole}>{role}</p>
          </div>
        </div>

        <div className={s.socialMediaContainer}>
          <SocialMediaLinks
            facebook={facebook}
            twitter={twitter}
            linkedIn={linkedIn}
            github={github}
            theme="light"
          />
        </div>
      </div>
    </div>
  );
};

export default BlogAuthor;
